'use client';

import { GetWrapupType, WrapupModuleKillsData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import IWrapupModule from "./imodule";
import WrapupModuleKillsContinued2Component from "./killscontd2component";

export default class WrapupModuleKillsContinued2 implements IWrapupModule {
    constructor() { }

    get id(): string { return 'killscontd2'; }
    get name(): string { return 'Kills Cont. 2'; }

    canRender(wrapupData: GetWrapupType): boolean {
        const killsData = wrapupData?.data?.kills as WrapupModuleKillsData;
        return killsData?.sprees?.length > 0;
    }

    getComponentClass() {
        return WrapupModuleKillsContinued2Component;
    }
}
